module.exports = __webpack_public_path__ + "static/bg-24b3fb20a2ade887b6c19166ff5a5e8e.jpg";